module.exports = __webpack_public_path__ + "img/navigate_next.83b08769.svg";